import React from 'react';
import LazyPageLoader from '../../cmp/LazyPageLoader';
import useScrollToTop from "../../../hooks/useScrollToTop";

const Page = React.lazy(()=>import('./LandingLegalIndex'))

export default function LandingLegalIndex(props){

    return <React.Suspense fallback={<LazyPageLoader />}>
        <Page />
    </React.Suspense>
}
